<div class="row">
    <div class="col-sm-9 text-right">
        <h4>
            Interrelaciones de Tendencias y Megatendecias
        </h4>
    </div>
    <div class="col-sm-3 text-end" style="text-size-adjust: 12px;">
        <a [routerLink]="'../../add-info/' + idInter" class="btn-add">
            <i class="fa fa-file-text" aria-hidden="true"></i> Texto introductorio
        </a>
    </div>
</div>
<br><br>

<h6 class="text-start">1. Seleccionar Tendencia :</h6>
<div class="row">
    <div class="textOnInput col-12">
        <label class="form-label">Tendencias</label>
        <select class="form-select form-input" [(ngModel)]="selectedTrend" (change)="onTrendSelected(selectedTrend)">
            <option selected [ngValue]="null" disabled>Seleccione una tendencias...</option>
            <option *ngFor="let t of trends" [ngValue]="t"> {{ t.code}}_{{ t.shorttitle}}
            </option>
        </select>
    </div>
</div>

<hr><br>
<h6 class="text-start">2. Relacionar con Megatendencias :</h6>
<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">

    <div class="form-group row">

        <div class="textOnInput col-6 col-md-6">
            <label class="form-label">Megatendecias</label>
            <select class="form-select form-input" formControlName="idtier3"
                [class.is-invalid]="invalidField('idtier3')">
                <option selected [ngValue]="null" disabled>Seleccione una megatendencia...</option>
                <ng-container *ngFor="let m of megatrends; let i = index">
                    <option [ngValue]="m.id" [disabled]="MegatrendSelected(m.code)"
                        [ngClass]="{ 'disabled-option': MegatrendSelected(m.code) }">
                        {{ m.code}}_{{ m.shorttitle}}</option>
                </ng-container>
            </select>
            <small class="text-danger" *ngIf="invalidField('idtier3')">Este campo es
                requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6">
            <label class="form-label">Relación</label>
            <select class="form-select form-input" formControlName="relation"
                [class.is-invalid]="invalidField('relation')">
                <option selected [ngValue]="null" disabled>Seleccione la relación...</option>
                <option *ngFor="let r of relation" [ngValue]="r.value">
                    {{r.title}}
                </option>
            </select>
            <small class="text-danger" *ngIf="invalidField('relation')">Este campo es
                requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Visible/oculto</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                </div>
            </div>
        </div>

        <input type="hidden" formControlName="id">
    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="afterSaveOrUpdate()">
                        Cancelar
                    </button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </div>
            </div>
        </div>
    </div>

</form>

<!-- Termina Formulario  -->

<hr>

<!-- Incia lista de interrelaciones megatendencia a tendencias -->
<br>
<div class="col-md-12">
    <div class="row">
        <h6>Lista de interrelaciones para: {{ selectedtrendName }}</h6>
        <div class="table-responsive">
            <table class="table">
                <thead class="thead-detail text-center table-success">
                    <tr>
                        <th scope="col">N°</th>
                        <th scope="col">titulo</th>
                        <th scope="col">relación</th>
                        <th scope="col">Estado</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="tbody-detail" *ngFor="let obj of listInterrelationship; let i = index">
                        <td>{{ i + 1 }}</td>
                        <td class="text-center">{{ obj.shorttitle +' '+ obj.code}}</td>
                        <td class="text-center">{{ getRelationTitle(obj.relation) }}</td>
                        <td class="text-center">
                            <div class="label-active" *ngIf="obj.status">ACTIVO</div>
                            <div class="label-inactive" *ngIf="!obj.status">INACTIVO</div>
                        </td>
                        <td class="text-center">
                            <a class="a-icon" (click)="loadToEditInterrelationship(obj)"><i
                                    class="fa fa-pencil i-icon"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Termina lista de megatendencia a tendencias -->